import { Button, Col, Drawer, Row } from 'antd';
import Title from 'antd/lib/typography/Title';

interface WorkRecordEmptyDrawerProps {
  visibleEmptyDrawer: boolean;
  openCreateDrawer: () => void;
  onClose: () => void;
}

function WorkRecordEmptyDrawer({
  visibleEmptyDrawer,
  openCreateDrawer,
  onClose,
}: WorkRecordEmptyDrawerProps) {
  return (
    <>
      <Drawer
        width={600}
        placement="right"
        closable={false}
        onClose={onClose}
        open={visibleEmptyDrawer}
      >
        {visibleEmptyDrawer && (
          <>
            <Row
              justify={'center'}
              style={{ marginTop: '40px', marginBottom: '20px' }}
            >
              <Col>
                <Title level={5}>작업일보이 존재하지 않습니다.</Title>
              </Col>
            </Row>
            <Row justify={'center'}>
              <Col>
                <Button
                  onClick={() => {
                    onClose();
                    openCreateDrawer();
                  }}
                >
                  작업일보 추가
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Drawer>
    </>
  );
}

export default WorkRecordEmptyDrawer;
